<div class="common-layout">
  <div class="logo-layout-sm sm-show">
    <template *ngTemplateOutlet="logo"></template>
  </div>
  <div class="header">
    <div class="content">
      <template *ngTemplateOutlet="logo"></template>
      <div>
        <h2 class="title">Your order</h2>
        <h3 class="sub-title">30-Day Money Back Guarantee. No Contracts. Free Shipping.</h3>
      </div>
      <a class="phone" href="tel:806-855-8255">806-855-8255</a>
    </div>
  </div>
  <!-- Special Promo banner -->
  <div *ngIf="orderState.promoVendor" class="banner-wrapper">
    <h3>{{ promoBannerTitle }}</h3>
  </div>

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>

<ng-template #logo>
  <a
    class="logo-wrapper"
    [class.jobber]="orderState.promoVendor === 'jobber'"
    [class.housecall-pro]="orderState.promoVendor === 'hcp-molly-maid'"
    [class.geico]="orderState.promoVendor === 'geico'"
    target="_self"
    [href]="homeUrl"
  >
    <img class="logo" [src]="logoAssetPath" />
  </a>
</ng-template>
